module.exports = __webpack_public_path__ + "static/media/team-1.6199a2ce.jpg";